export default "__VITE_ASSET__C5Ymp_Gw__"